import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function BeginYourJourneyToClarity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="begin-your-journey-to-clarity" className="dark bg-background text-foreground relative overflow-hidden py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-10 pointer-events-none mix-blend-overlay">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550923/img/subtle_grain_texture.png')] bg-repeat opacity-50" />
      </div>

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-4xl mx-auto space-y-10">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-tight text-foreground">
            Ready to uncover the clarity you deserve?
          </h2>
          
          <div className="flex justify-center">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg px-8 py-6 h-auto rounded-full shadow-[0_0_20px_rgba(45,212,191,0.3)] hover:shadow-[0_0_30px_rgba(45,212,191,0.5)] transition-all duration-300">
              <Link to="https://sharmatpsychiatricgroup.com/contact/">
                Book Your Consultation
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}